import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DashboardReportingQueryTypes, IReportDateRange, ReportDao } from '../../../../core/services/dao/reportDao';
import { Subscription } from 'rxjs';
import { Brand } from '../../../../core/models/brand';
export type SpotLiftRecord = {
  isci: string;
  percentLift: number;
  airingCount: number;
  sessionCount: number;
  baselineCount: number;
  affiliates: { name: string; airingCount: number }[];
};

@Component({
  selector: 'lift-by-spot-tile',
  templateUrl: './lift-by-spot-tile.component.html',
  styleUrls: ['lift-by-spot-tile.component.scss']
})
export class LiftBySpotTileComponent implements OnInit, OnDestroy {
  @Input() brand: Brand;
  @Input() creatives: Array<string>;
  private subs: any[] = [];
  public loadingData = false;
  public topThree = [];
  public averageLift: number;
  @Output() showLiftFull = new EventEmitter();

  constructor() {}

  ngOnInit() {
   this.topThree = [
      {
        spot: {
          avgPctLift: 156.77,
          isci: 'GE31W2',
          _id: { isci: 'GE31W2' }
        },
        class: 'border primary-color',
        id: 1
      },
      {
        spot: {
          avgPctLift: 153.83,
          isci: 'GE31W1',
          _id: { isci: ' GE31W1' }
        },
        class: 'border primary-color',
        id: 2
      },
      {
        spot: {
          avgPctLift: 125.98,
          isci: 'GF31W1',
          _id: { isci: 'GF31W1' }
        },
        class: 'primary-color',
        id: 3
      }
    ];
   this.averageLift = 133
  }

  showFull() {
    this.showLiftFull.emit({ averageLift: this.averageLift });
  }
  formatIsci(isci: string): string {
    if (isci?.length > 15) {
      return isci.substr(0, 12) + '...';
    } else {
      return isci;
    }
  }

  trackByFn = (index: number, item: any) => item.id;

  ngOnDestroy() {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
